
/**
 *  Read More JS
 *  Truncates text via specfied character length with more/less actions.
 *  Maintains original format of pre truncated text.
 *  @author stephen scaff
 *  @todo   Add destroy method for ajaxed content support.
 *
 */
 const ReadMore = (() => {
   let s;

   return {

     settings() {
       return {
         content: document.querySelectorAll('.js-read-more'),
         originalContentArr: [],
         truncatedContentArr: [],
         moreLink: "Read More",
         lessLink: "Read Less",
       }
     },

     init() {
       s = this.settings();
       this.bindEvents();
     },

     bindEvents() {
       ReadMore.truncateText();
     },

     /**
      * Count Words
      * Helper to handle word count.
      * @param {string} str - Target content string.
      */
     countWords(str) {
       return str.split(/\s+/).length;
     },

     /**
      * Ellpise Content
      * @param {string} str - content string.
      * @param {number} wordsNum - Number of words to show before truncation.
      */
     ellipseContent(str, wordsNum) {
       return str.split(/\s+/).slice(0, wordsNum).join(' ') + '...';
     },

     /**
      * Truncate Text
      * Truncate and ellipses contented content
      * based on specified word count.
      * Calls createLink() and handleClick() methods.
      */
     truncateText() {

       for (let i = 0; i < s.content.length; i++) {
         //console.log(s.content)
         const originalContent = s.content[i].innerHTML;
         const numberOfWords = s.content[i].dataset.rmWords;
         const truncateContent = ReadMore.ellipseContent(originalContent, numberOfWords);
         const originalContentWords = ReadMore.countWords(originalContent);

         s.originalContentArr.push(originalContent);
         s.truncatedContentArr.push(truncateContent);

         if (numberOfWords < originalContentWords) {
           s.content[i].innerHTML = s.truncatedContentArr[i];
           let self = i;
           ReadMore.createLink(self)
         }
       }
       ReadMore.handleClick(s.content);
     },

     /**
      * Create Link
      * Creates and Inserts Read More Link
      * @param {number} index - index reference of looped item
      */
     createLink(index) {
       const linkWrap = document.createElement('span');

       linkWrap.className = 'read-more__link-wrap';

       linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;

       // Inset created link
       s.content[index].parentNode.insertBefore(linkWrap, s.content[index].nextSibling);

     },

     /**
      * Handle Click
      * Toggle Click eve
      */
     handleClick(el) {
       const readMoreLink = document.querySelectorAll('.read-more__link');

       for (let j = 0, l = readMoreLink.length; j < l; j++) {

         readMoreLink[j].addEventListener('click', function() {

           const moreLinkID = this.getAttribute('id');
           let index = moreLinkID.split('_')[1];

           el[index].classList.toggle('is-expanded');

           if (this.dataset.clicked !== 'true') {
              el[index].innerHTML = s.originalContentArr[index];
              this.innerHTML = s.lessLink;
              this.dataset.clicked = true;
           } else {
             el[index].innerHTML = s.truncatedContentArr[index];
             this.innerHTML = s.moreLink;
             this.dataset.clicked = false;
           }
         });
       }
     },

     /**
      * Open All
      * Method to expand all instances on the page.
      */
     openAll() {
       const instances = document.querySelectorAll('.read-more__link');
         for (let i = 0; i < instances.length; i++) {
           content[i].innerHTML = s.truncatedContentArr[i];
           instances[i].innerHTML = s.moreLink;
         }
       }
     }
 })();


const items = document.querySelector("#section-header > div > div:nth-child(1) > nav > ul").children;

for (let i = 0;i < items.length;i++) {
    const item = items[i];
  if (item.ariaHasPopup) {
      item.classList.add('test');
    }
}


for (const a of document.querySelectorAll(".CollectionFilters a")) {
  if (a.textContent.includes("Mother") && a.classList.contains("Link")) {
    a.classList.add('bold-special');
  }
}


var button = document.querySelector('.read-more');

if (button) {
  button.addEventListener('click', function(event) {
    var span = document.querySelector('.show-more .more');
    span.classList.toggle('fade-in');
  });  
}


var showMoreCollections = document.querySelector('.show-more-collections');

if (showMoreCollections) {
  showMoreCollections.addEventListener('click', function(event) {
  const block = document.querySelector('#collection-list-custom-123 .CollectionList');
  block.classList.toggle('all');
});
}

document.addEventListener("DOMContentLoaded", function(event) { 
  const elem = document.querySelector('#shopify-section-template--14246165610576__163759931822cb5fa6 p');
    if (elem) {
        elem.classList.add('js-read-more');
  
        elem.setAttribute('data-rm-words', 18) 

        if (document.querySelector('.js-read-more')) {
          ReadMore.init();
        }
    }
});


jQuery('.flowers-list .DropdownMenu li a').on('click', function() {
  jQuery('.flowers-list .DropdownMenu').toggleClass('visible');
  jQuery('.flowers-list .Heading img').toggleClass('down');
  jQuery('.flowers-list').toggleClass('flowers-list--active');
  const url = jQuery(this).data('link');
  window.location.href = url;
});


jQuery('.flowers-list.HorizontalList__Item .Heading').on('click', function() {
  jQuery('.occasions-list .DropdownMenu').removeClass('visible');
  jQuery('.flowers-list .DropdownMenu').toggleClass('visible');
  jQuery('.occasions-list').removeClass('occasions-list--active');
  jQuery('.flowers-list').toggleClass('flowers-list--active');
});


jQuery('.occasions-list .DropdownMenu li a').on('click', function() {
  jQuery('.occasions-list .DropdownMenu').toggleClass('visible');
  jQuery('.occasions-list .Heading img').toggleClass('down');
  jQuery('.occasions-list').toggleClass('occasions-list--active');
  const url = jQuery(this).data('link');
  window.location.href = url;
});


jQuery('.occasions-list.HorizontalList__Item .Heading').on('click', function() {
  jQuery('.flowers-list .DropdownMenu').removeClass('visible');
  jQuery('.occasions-list .DropdownMenu').toggleClass('visible');
  jQuery('.flowers-list').removeClass('flowers-list--active');
  jQuery('.occasions-list').toggleClass('occasions-list--active');
});

document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('click', e => {
    const btns_click_target_close = e.target;
    if (!btns_click_target_close.closest('.flowers-list.HorizontalList__Item .Heading ') && !btns_click_target_close.closest('.flowers-list.HorizontalList__Item .DropdownMenu')) { 
      jQuery(".flowers-list.HorizontalList__Item .DropdownMenu").removeClass('visible');
      jQuery('.flowers-list').removeClass('flowers-list--active');
    } 
    if (!btns_click_target_close.closest('.occasions-list.HorizontalList__Item .Heading ') && !btns_click_target_close.closest('.occasions-list.HorizontalList__Item .DropdownMenu')) {
      jQuery(".occasions-list.HorizontalList__Item .DropdownMenu").removeClass('visible');
      jQuery('.occasions-list').removeClass('occasions-list--active');
    }
  });
});


// Adding an additional item to the cart
document.addEventListener("DOMContentLoaded", () => {
  const btn_add_to_cart = document.querySelectorAll(".product_btn_add_to_cart");
  const products_in_cart = [];

  jQuery.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
  }).then((data) => {
    data.items.forEach(function(item, i) {
      products_in_cart.push(item.id);
    });
    if (products_in_cart.length != 0) {
      btn_add_to_cart.forEach(function(item, i) {
        for (var x = 0; x < products_in_cart.length; x++) {
          if (btn_add_to_cart[i].getAttribute('data-id') == products_in_cart[x]) {
            btn_add_to_cart[i].innerHTML = "Remove to cart";
            btn_add_to_cart[i].setAttribute("data_product_status", "Remove from cart");
          }
        }
      });
    }
  });

  btn_add_to_cart.forEach(function(item) {
    item.addEventListener("click", function(e) {
      if (item.getAttribute('data_product_status') == "Add to cart") {
        item.setAttribute('disabled', 'disabled');

        fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(
              {
                form_type: "product",
                id: item.getAttribute('data-variant-id'),
                product_id: item.getAttribute('data-id'),
                quantity: 1
              }
            ),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        
            }
        }).then(function(response) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            if (response.ok) {
              item.setAttribute('disabled', '');
              item.innerHTML = "Remove to cart";
              item.setAttribute("data_product_status", "Remove from cart");
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
        });

        
        // jQuery.ajax({
        //     type: "POST",
        //     url: "/cart/add.js",
        //     dataType: "json",
        //     data: {
        //       id: item.getAttribute('data-id'),
        //       quantity: 1,
        //     },
        //   }).then((data) => {
        //     item.setAttribute('disabled', '');
        //     item.innerHTML = "Remove to cart";
        //     item.setAttribute("data_product_status", "Remove from cart");
        //     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        //   });


        
      } else if (item.getAttribute('data_product_status') == "Remove from cart") {
        item.setAttribute('disabled', 'disabled');
        jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
              id: item.getAttribute('data-id'),
              quantity: 0,
            },
        }).then((data) => {
            item.setAttribute('disabled', '');
            item.innerHTML = "Add to cart";
            item.setAttribute("data_product_status", "Add to cart");
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      }
    });
  });
});
// end: Adding an additional item to the cart

document.addEventListener("DOMContentLoaded", function() {
  setupCustomAnalytics();
});

function setupCustomAnalytics() {
  function handleClick(e) {
    if (e.target.closest('button').classList.contains('wishlisthero-product-in-wishlist')) {
      // In wishlisthero, removing product
      gtag("event", "remove_from_wishlist", {
          "event_category": "All"
      });
    } else {
      // In wishlisthero, adding product
      gtag("event", "add_to_wishlist", {
          "event_category": "All"
      });
    }
  }
  const wishlistButtons = document.querySelectorAll(".wishlist-hero-custom-button");
  wishlistButtons.forEach(function(item) {
    item.addEventListener("click", function(e) {
      handleClick(e);
    });
  });

  document.body.addEventListener("click", function (event) {
    const element = event.target.closest('#wishlisthero-product-page-button-container button');
    console.log('element', element);
    if (element) {
     handleClick(event);
    }
  });
};

// Setup discount
function setupDiscount() {
  // не всегда есьт прокомод на скидку, поэтому убрал
  // const discount_code = this.getCookie('discount_code');

  // if (!discount_code) return;

  // const discount_right = document.querySelector('.discount__right');
  // if (!discount_right) return;

  // const cart_total = document.querySelector('.Cart__Total');
  // if (!cart_total) return;

  // const price = parseInt(cart_total.textContent.replace('$', '').replace(' USD', '').replace(',', ''));

  // const new_price = price * 0.9;
  // const discount_price = price * 0.1;

  // const discount_price_string = '-$' + (discount_price).toLocaleString(
  //   'en-US',
  //   { minimumFractionDigits: 2 }
  // );

  // discount_right.innerHTML = discount_price_string

  // const new_price_string = '$' + (new_price).toLocaleString(
  //   'en-US',
  //   { minimumFractionDigits: 2 }
  // );
  
  // cart_total.innerHTML = new_price_string;

  // const discount__row = document.querySelector('.discount__row');
  
  // if (!discount__row) return;
  // console.log('discount__row', discount__row);
  // discount__row.classList.remove('hidden');
}

window.setupDiscount = setupDiscount;

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// Discount Apply
document.body.addEventListener('click', function (evt) {
    if (evt.target.classList.contains('copy-to-clipboard')) {
        evt.target.text = "Applied";

        let code = evt.target.getAttribute('data-promocode');
        fetch('https://floral5.com/discount/' + code).then(function(response) {
          return response.json();
        }).then(function(data) {
        }).catch(function() {
        }).finally(function() {
          window.setupDiscount();
        });
    }
}, false);


